import { Column } from './Column/Column'
import { Columns } from './MultiColumn.models'
import { Container, ContainerWrapper, StyledColumn } from './MultiColumn.style'

export const MultiColumn = ({ columns, backgroundColor }: Columns) => {

    return (
        <ContainerWrapper>
             <Container backgroundColor={backgroundColor}>
                {columns && columns.length > 0 &&
                    columns.map((column, index) => {
                        return (
                            <StyledColumn key={index} colCount={columns.length} backgroundColor={backgroundColor}>
                                <Column {...column} />
                            </StyledColumn>
                        );
                    })}
            </Container>
        </ContainerWrapper>
    );
}
